/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmExecutionGroupFilters {
    getFixupPrototypeFunction() { return AwsSsmExecutionGroupFilters.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmExecutionGroupFilters>): AwsSsmExecutionGroupFilters {
        let obj = Object.assign(new AwsSsmExecutionGroupFilters(), model);
        AwsSsmExecutionGroupFilters.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmExecutionGroupFilters>): AwsSsmExecutionGroupFilters {
        if (!model) return null;
        return AwsSsmExecutionGroupFilters.newInstance(<AwsSsmExecutionGroupFilters> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmExecutionGroupFilters) {
        if (!obj) return;

        models.AwsSsmExecutionGroupFilters.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmExecutionGroupFilters): boolean {
        Object.setPrototypeOf(obj, AwsSsmExecutionGroupFilters.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of ids of the cloud account.
     */
    cloud_account_ids: Array<string>;

    /**
     * region of the document to be executed.
     */
    regions: Array<string>;

    /**
     * Name of the document.
     */
    document_ids: Array<string>;

    /**
     * Type of the executed document
     */
    document_types: Array<string>;

    /**
     * IAM ARN of the user who executed the document
     */
    executed_by: Array<string>;

    /**
     * Status of the Automation Execution
     */
    status: models.AwsSsmAutomationExecutionStatus;

    /**
     * Text query for Document Executions list. Search by Execution Id and Document Name
     */
    text_query: string;

}
